<i18n>
{
	"en": {
		"confirmEdiSent": "EDI has already been sent. Are you sure you want to change address?",
		"confirmDatesSet": "ATD or ATA has already been set. Are you sure you want to change address?"
	},
	"no": {
		"confirmEdiSent": "EDI er allerede sendt. Are you sure you want to change address?",
		"confirmDatesSet": "ATD eller ATA er allerede satt. Are you sure you want to change address?"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:hasHeader="false"
		icon="cog"
		iconType="bp"
		width="480px"
		@ok="$emit('confirm')"
		@cancel="$emit('cancel')"
		@close="$emit('close')"
	>
		{{ ediSent ? $t('confirmEdiSent') : $t('confirmDatesSet')}}
	</t-dialog>
</template>

<script>


export default {
	name: 'ConfirmEditAddress',
	props: {
		isShown: Boolean,
		order: Object,
		ediSent: Boolean
	},
};
</script>
